exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".map-wrapper>div[data-v-50fcdc54]{position:absolute;top:0;left:0;width:100%;height:100%}", ""]);

// exports
